export default __webpack_public_path__ + "static/hero.light-0f3a56dab0a7e9f658b9e8ebce5eb0c112ee807c8460cd749706517eb7f413e9.png";